// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"938c2afa","276":"298b9283","382":"d9f0b262","387":"3e956a66","419":"c958e1dc","425":"494adb5f","480":"2d046c7e","527":"c87eda05","581":"c9006cd8"}[chunkId] + ".chunk.css";
};